import { Tooltip as ReactTooltip } from 'react-tooltip';
import styled from 'styled-components';

import { BRAND_COLORS } from './colors';
import { TYPOGRAPHY } from './typography';

export const Tooltip = styled(ReactTooltip).attrs({
  arrowColor: BRAND_COLORS.black,
  opacity: 1,
  delayHide: 500,
  // Note - right-start fits the design better, but causes issues with the border-radius
  place: 'right',
  classNameArrow: 'react-tooltip-arrow',
  clickable: true,
  openEvents: {
    mouseover: true,
    click: true,
  },
  closeEvents: {
    mouseout: true,
  },
  globalCloseEvents: {
    clickOutsideAnchor: true,
  },
})`
  && {
    z-index: 1000;

    ${TYPOGRAPHY.CIRCULAR.book}
    font-size: 14px;
    line-height: 20px;
    color: ${BRAND_COLORS.white};

    padding: 12px 16px;
    max-width: 260px;

    border-radius: 8px;

    background-color: ${BRAND_COLORS.black};
  }
`;
